import { FC } from 'react';
import styled from 'styled-components';

import { Controls, ControlsButton } from '@/components/Controls';
import Text from '@/components/Text';

const StyledControls = styled(Controls)`
  display: flex;
  margin-top: 8px;
`;

const StyledControlsButton = styled(ControlsButton)`
  flex: 1;
  justify-content: center;
`;

const InfoBox = styled.div`
  margin-top: 16px;
  padding: 16px;
  border-radius: 4px;
  border: solid 1px ${({ theme }) => theme.colors.grayscale};
`;

const Description = styled(Text)`
  margin-top: 12px;
  a {
    font-weight: 700;
    text-decoration: underline;
    transition: color ease-out 0.2s;
    &:hover {
      color: ${({ theme }) => theme.colors.black};
    }
  }
`;

interface Props {
  isChannelGroups: boolean;
  setIsChannelGroups: React.Dispatch<React.SetStateAction<boolean>>;
}

const FormPageGroupSwitch: FC<Props> = ({
  isChannelGroups,
  setIsChannelGroups,
}) => {
  return (
    <>
      <StyledControls>
        <StyledControlsButton
          type="button"
          gray
          blackText
          active={!isChannelGroups}
          onClick={() => setIsChannelGroups(false)}
        >
          Page
        </StyledControlsButton>
        <StyledControlsButton
          type="button"
          gray
          blackText
          active={isChannelGroups}
          onClick={() => setIsChannelGroups(true)}
        >
          Group
        </StyledControlsButton>
      </StyledControls>
      {isChannelGroups && (
        <InfoBox>
          <Text $type="smallBold">Page Groups</Text>
          <Description $color="gray" $type="smallNormal">
            Page groups can be created and modified in Crafty Panda team
            settings.
            <a
              href="/teams/2/distribution/settings/groups"
              target="_blank"
              rel="noreferrer noopener"
            >
              Navigate to Crafty Panda → Settings → Channel Groups tab
            </a>
          </Description>
        </InfoBox>
      )}
    </>
  );
};

export default FormPageGroupSwitch;
